import React from 'react'
import { Link } from 'gatsby'
import { useRecoilState } from 'recoil'
import styled from '@emotion/styled'

import { MdModeNight, MdFormatListBulleted } from 'react-icons/md'
import { HiOutlineLightBulb } from 'react-icons/hi'

import { commonStore } from '~/states/commonStore'

import Route from '~/constants/route'

import LightLogo from '~/assets/svg/logo-light.inline.svg'
import DarkLogo from '~/assets/svg/logo-dark.inline.svg'

const Header: React.VFC = () => {
  const [{ mode }, setCommon] = useRecoilState(commonStore)
  const isLightMode = mode === 'light'

  const handleThemeMode = () => {
    const newMode = isLightMode ? 'dark' : 'light'

    setCommon(prevCommon => ({
      ...prevCommon,
      mode: newMode,
    }))
    localStorage.setItem('mode', newMode)
  }

  return (
    <Container>
      <Wrapper>
        <Link to={Route.main}>
          {isLightMode ? (
            <LightLogo width={120} className="logo" />
          ) : (
            <DarkLogo width={120} className="logo" />
          )}
        </Link>

        <nav>
          <LinkList>
            <li>
              <button type="button" onClick={handleThemeMode}>
                {isLightMode ? <MdModeNight /> : <HiOutlineLightBulb />}
              </button>
            </li>
            <li>
              <Link to={Route.post}>
                <MdFormatListBulleted />
              </Link>
            </li>
          </LinkList>
        </nav>
      </Wrapper>
    </Container>
  )
}

const Container = styled.header`
  width: 100%;
  height: ${({ theme: { height } }) => height.header}px;
  padding: 0 ${({ theme: { padding } }) => padding.desktop}px;

  position: fixed;
  top: 0;
  left: 0;
  z-index: ${({ theme: { zIndex } }) => zIndex.header};

  display: flex;
  justify-content: center;

  box-shadow: 0 2px 2.5px rgb(0 0 0 / 7%);
  background-color: ${({ theme: { colors } }) => colors.bgColor};
`

const Wrapper = styled.div`
  width: min(${({ theme: { width } }) => width.main}px, 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const LinkList = styled.ul`
  display: flex;
  column-gap: 15px;

  > li svg {
    color: ${({ theme: { colors } }) => colors.darkText};
  }
`

export default Header
